// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0993c72c","455":"e0722a5c"}[chunkId] + ".chunk.js";
};